import { createContext, useContext } from 'react';

export const LinkLoginContext = createContext({
  linkMode: false,
  linkToken: null,
  onSuccess: null,
});

export function useLinkLogin() {
  return useContext(LinkLoginContext);
}
